import ProfileBodyWithTabs from './ProfileBodyWithTabs'

export default ProfileBodyWithTabs
